"use client";
import { useSession } from "next-auth/react";
import Link from "next/link";
import React from "react";
// import { useAuth0 } from "@auth0/auth0-react";
import { signOut } from "next-auth/react";
import { clearDatadogUser } from "@/utils/datadog";
import { AiOutlineCalendar, AiOutlineSchedule } from "react-icons/ai";
import { CgMenuHotdog } from "react-icons/cg";
import { GoGitMergeQueue } from "react-icons/go";
import { GrServers } from "react-icons/gr";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { MdOutlineLocationCity } from "react-icons/md";
import { PiUsersFill } from "react-icons/pi";
import { TbCloudDataConnection } from "react-icons/tb";
import { VscSettings } from "react-icons/vsc";
import Logo from "../../images/svg/logo.svg";


import { unlock } from "@/data/calls/operator";
import Image from "next/image";
import { BsCameraVideoFill } from "react-icons/bs";
import {
  MdCrisisAlert,
  MdLogout,
  MdSpaceDashboard
} from "react-icons/md";
import { PiSpeakerSimpleHighBold, PiVideoCameraFill } from "react-icons/pi";
import { toast } from "react-hot-toast";
import ZohoBugReportButton from "@/components/queue/ZohoBugReportButton";
import { BiBug } from "react-icons/bi";
import { FaUser } from "react-icons/fa";

const AdminSideBar = () => {
  let side;
  if (typeof window !== "undefined") {
    side = localStorage.getItem("showSidebar") === "true" ? true : false;
  }
  const [showSidebar, setShowSidebar] = React.useState<boolean>(side || false);
  const [opts, setOpts] = React.useState(true);
  const [profileHovered, setProfileHovered] = React.useState(false);
  const hideTimeout = React.useRef<NodeJS.Timeout | null>(null);
  const { data, status }: any = useSession();
  const session = data?.session || null;
  const token = data?.token || null;
  // const { logout } = useAuth0();
  const toggleShowOpts = (value: any = null) => {
    if (value !== null) {
      if (value !== opts) setOpts(!opts);
    } else {
      setOpts(!opts);
    }
  };
  const handleToggleSideBar = (status: boolean | null = null) => {
    const newState = status === null ? !showSidebar : status;
    setShowSidebar(newState);
    if (typeof window !== "undefined") {
      localStorage.setItem("showSidebar", String(newState));
    }
  };

  if (status === "authenticated")
    return (
      <>
        {/* <pre>{JSON.stringify(session, null, 2)}</pre> */}
        <div
          className={`h-screen transition-all duration-150 ease-in-out ${showSidebar ? "w-64 bg-gray-300" : "w-16 bg-gray-500"
            }`}
        ></div>
        <div
          className={` min-h-screen dark:bg-gray-900 ${showSidebar ? "w-56 bg-gray-300" : "w-16 bg-gray-500"
            } fixed transition-all duration-150 ease-in-out flex flex-col z-50`}
        >
          <div className={`flex items-center px-4 py-2 ${showSidebar ? "justify-between" : "justify-center"}`}>
            {showSidebar && (
              <Image
                src={Logo}
                alt="Logo"
                width={100}
                className="select-none"
                draggable={false}
              />
            )}
            <button
              onClick={() => handleToggleSideBar()}
              className="flex h-12 w-12 items-center justify-center border-none text-gray-700 outline-none transition-all duration-150 delay-100 ease-in-out hover:text-blue-900"
              aria-label="Toggle sidebar"
            >
              <CgMenuHotdog
                className={`${!showSidebar ? "text-3xl" : ""
                  } transition-all duration-150 ease-out`}
              />
            </button>
          </div>
          <NavItems showSidebar={showSidebar} handleToggleSideBar={handleToggleSideBar} />
          <div className="mt-auto w-full p-4">
            <div className="flex items-center justify-center mb-4">
              <div className="relative group">
                <button
                  type="button"
                  aria-label="Report an issue"
                  onClick={() => {
                    const wrapper = document.getElementById("sidebar-bug-btn-wrapper");
                    if (wrapper) {
                      const btn = wrapper.querySelector("button");
                      if (btn) btn.click();
                    }
                  }}
                  className={`flex items-center justify-center transition-colors duration-150 rounded-md focus:outline-none
                    ${showSidebar ? "w-full px-3 py-2 gap-2 bg-blue-100 hover:bg-blue-200" : "w-12 h-12 bg-blue-100 hover:bg-blue-200"}
                  `}
                >
                  <BiBug className={`text-2xl ${showSidebar ? "text-blue-700" : "text-blue-700"}`} />
                  {showSidebar && <span className="text-blue-900 font-medium text-base">Report an issue</span>}
                </button>
                {!showSidebar && (
                  <div className="pointer-events-none absolute left-full top-1/2 -translate-y-1/2 ml-4 z-50 whitespace-nowrap rounded-md bg-black px-2 py-1 text-sm text-white opacity-0 transition-opacity group-hover:pointer-events-auto group-hover:opacity-100">
                    Report an issue
                  </div>
                )}
                <div style={{ display: "none" }} id="sidebar-bug-btn-wrapper">
                  <ZohoBugReportButton setReportSent={() => { }} />
                </div>
              </div>
            </div>
            <div
              className="group relative flex items-center justify-center"
              onMouseEnter={() => {
                if (hideTimeout.current) {
                  clearTimeout(hideTimeout.current);
                  hideTimeout.current = null;
                }
                setProfileHovered(true);
              }}
              onMouseLeave={() => {
                hideTimeout.current = setTimeout(() => {
                  setProfileHovered(false);
                }, 200);
              }}
            >
              <button
                className="flex h-12 w-12 cursor-pointer items-center justify-center rounded-full focus:outline-none"
                onClick={() => toggleShowOpts()}
              >
                {token && token?.image ? (
                  <img
                    src={token?.image}
                    alt="profile"
                    className="rounded-full"
                  />
                ) : (
                  <span
                    className=" text-lg font-medium leading-none text-white"
                  >
                    {token?.email ? token?.email[0].toUpperCase() : "?"}
                  </span>
                )}
              </button>
              {(showSidebar || profileHovered) && (
                <div
                  className={`${showSidebar
                    ? "ml-2"
                    : "absolute left-full top-1/2 -translate-y-1/2 ml-2 transform z-50 rounded-md px-2 py-1 bg-blue-500"
                    } transition-opacity duration-300`}
                  onMouseEnter={() => {
                    if (hideTimeout.current) {
                      clearTimeout(hideTimeout.current);
                      hideTimeout.current = null;
                    }
                    setProfileHovered(true);
                  }}
                  onMouseLeave={() => {
                    hideTimeout.current = setTimeout(() => {
                      setProfileHovered(false);
                    }, 200);
                  }}
                >
                  {!showSidebar && (
                    <Link
                      href="/user"
                      className="focus:outline-none whitespace-nowrap text-lg outline-none transition duration-150 ease-in-out block rounded-md px-3 py-1 text-white hover:bg-blue-700"
                    >
                      <div className="flex items-center gap-2">
                        <span className="pl-4">My Profile</span>
                        <FaUser />
                      </div>
                    </Link>
                  )}
                  <button
                    onClick={async () => {
                      try {
                        await unlock();
                        // Clear Datadog user context on logout
                        clearDatadogUser();
                        localStorage.removeItem("@BLUE-access_token");
                        localStorage.removeItem("@BLUE-user");
                        localStorage.removeItem("@BLUE-id_token");
                        localStorage.removeItem("@BLUE-expires_at");
                        await signOut({
                          callbackUrl: "/",
                        });
                      } catch (err: any) {
                        toast.error(`Error logging out: ${err.message}`);
                      }
                    }}
                    className={`focus:outline-nones whitespace-nowrap text-lg outline-none transition duration-150 ease-in-out ${showSidebar ? "text-gray-900 mr-4 hover:text-blue-700 py-1" : "rounded-md px-3 py-1 text-white hover:bg-blue-700"
                      }`}
                  >
                    <div className="flex items-center gap-2">
                      <span className="pl-4">Log Out</span>
                      <MdLogout />
                    </div>
                  </button>
                </div>
              )}
            </div>
            {/* Version number display */}
            <div className={`mt-2 ${showSidebar ? "text-center" : "flex items-center justify-center"}`}>
              <span
                className={`text-xs whitespace-nowrap ${showSidebar ? "text-gray-600 dark:text-gray-400" : "text-gray-200 truncate max-w-[3.5rem]"}`}
                title={(() => {
                  const version = process.env.NEXT_PUBLIC_DD_VERSION || '1.0.0_local';  // this env var is the one that is set at build time, so it is okay to reference process.env in this client-side component
                  return version.startsWith('v') ? version : `v${version}`;
                })()}
              >
                {(() => {
                  const version = process.env.NEXT_PUBLIC_DD_VERSION || '1.0.0_local';
                  return version.startsWith('v') ? version : `v${version}`;
                })()}
              </span>
            </div>
          </div>
        </div >
      </>
    );
  return null;
};
export default AdminSideBar;

const NavItems = ({ handleToggleSideBar, showSidebar }: any) => {
  const menuItems = [
    {
      name: "Queue",
      icon: <GoGitMergeQueue />,
      path: "/queue",
    },
    {
      name: "Alerts",
      icon: <MdCrisisAlert />,
      path: "/alerts",
    },
    {
      name: "Events",
      icon: <AiOutlineCalendar />,
      path: "/events",
    },
    {
      name: "Admin",
      icon: <MdSpaceDashboard />,
      path: "/admin",
    },
    {
      name: "Users",
      icon: <PiUsersFill />,
      path: "/users",
    },
    {
      name: "Sites",
      icon: <MdOutlineLocationCity />,
      path: "/locations",
    },
    {
      name: "Servers",
      icon: <GrServers />,
      path: "/servers",
    },
    {
      name: "Cameras",
      icon: <PiVideoCameraFill />,
      path: "/cameras",
      sons: [
        {
          name: "Create Camera",
          icon: <BsCameraVideoFill />,
          path: "/cameras/new",
        },
      ],
    },
    {
      name: "Speakers",
      icon: <PiSpeakerSimpleHighBold />,
      path: "/things",
    },
    {
      name: "Schedules",
      icon: <AiOutlineSchedule />,
      path: "/schedules",
    },

    {
      name: "Reports",
      icon: <HiOutlineDocumentReport />,
      path: "/reports",
    },
    {
      name: "Settings",
      icon: <VscSettings />,
      path: "/settings",
    },
  ];
  return (
    <ul className={`flex w-full flex-col gap-8 p-6 transition-all duration-200 ease-linear ${showSidebar ? 'items-start' : 'items-center'}`}>
      {menuItems.map((item: any) =>
        !item.disabled ? (
          <li key={item.name} className="group relative">
            <Link
              href={item.path}
              className="peer"
              onClick={() => {
                if (showSidebar) {
                  handleToggleSideBar(false)
                }
              }}
            >
              <div className={`flex w-full items-center gap-2 text-lg font-medium leading-5 text-gray-900 hover:text-blue-700`}>
                <div className="transition-transform duration-200 ease-in-out group-hover:scale-[1.5] text-2xl">
                  {item.icon}
                </div>
                {showSidebar && <span className="group hover:text-blue-700">{item.name}</span>}
              </div>
            </Link>
            {!showSidebar && (
              <div className="pointer-events-none absolute left-full top-1/2 -translate-y-1/2 ml-4 z-50 whitespace-nowrap rounded-md bg-black px-2 py-1 text-sm text-white opacity-0 transition-opacity group-hover:pointer-events-auto group-hover:opacity-100">
                {item.name}
              </div>
            )}
          </li>
        ) : (
          <li
            className="group relative flex w-full select-none flex-col gap-2 text-lg font-medium leading-5 text-gray-900"
            key={item.name}
          >
            <div className={`flex items-center gap-2 text-gray-900`}>
              <div className="transition-transform duration-200 ease-in-out group-hover:scale-[2] text-2xl">
                {item.icon}
              </div>
              {showSidebar && <span className="group hover:text-blue-700">{item.name}</span>}
            </div>
            {!showSidebar && (
              <div className="pointer-events-none absolute left-full top-1/2 -translate-y-1/2 ml-4 z-50 whitespace-nowrap rounded-md bg-black px-2 py-1 text-sm text-white opacity-0 transition-opacity group-hover:pointer-events-auto group-hover:opacity-100">
                {item.name}
              </div>
            )}
          </li>
        ),
      )}
    </ul>
  );
};
